import { render, staticRenderFns } from "./CollectionGallery.vue?vue&type=template&id=1ce801b8&"
import script from "./CollectionGallery.vue?vue&type=script&lang=js&"
export * from "./CollectionGallery.vue?vue&type=script&lang=js&"
import style0 from "./CollectionGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/melissaallen/fuzzco/pretendstore/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1ce801b8', component.options)
    } else {
      api.reload('1ce801b8', component.options)
    }
    module.hot.accept("./CollectionGallery.vue?vue&type=template&id=1ce801b8&", function () {
      api.rerender('1ce801b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/CollectionGallery.vue"
export default component.exports